import { Logo } from '@/components/ui/logo';
import { Button } from '@/components/ui/button';
import { Menu, Shield } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ThemeSelector } from '@/components/ThemeSelector';
import { FontSelector } from '@/components/FontSelector';
import { useNavigate } from 'react-router-dom';
import { SignedIn, UserButton } from "@clerk/clerk-react";
import { useServerRole } from '@/domain/auth/hooks/use-server-role';

export const Header = () => {
  const navigate = useNavigate();
  const { role } = useServerRole();
  const isAdmin = role === 'admin';

  return (
    <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 depth-glass sticky top-0 z-50">
      <div className="container flex h-20 items-center justify-between py-4">
        <button type="button" aria-label="DocVerifAI home" onClick={() => navigate('/app')} className="shrink-0 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">
          <Logo />
        </button>
        <div className="flex items-center gap-4">
          <SignedIn>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon" className="hover:bg-accent">
                  <Menu className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel>Settings</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {isAdmin && (
                  <>
                    <DropdownMenuItem className="cursor-pointer" onClick={() => navigate('/app/admin')}>
                      <Shield className="mr-2 h-4 w-4" />
                      <span>Admin Dashboard</span>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                  </>
                )}
                <div className="px-2 py-2">
                  <div className="mb-4">
                    <label className="text-sm font-medium mb-2 block">Theme</label>
                    <ThemeSelector />
                  </div>
                  <div>
                    <label className="text-sm font-medium mb-2 block">Font</label>
                    <FontSelector />
                  </div>
                </div>
              </DropdownMenuContent>
            </DropdownMenu>
            <UserButton
              afterSignOutUrl="/sign-in"
              appearance={{
                elements: {
                  // The app-wide Clerk appearance gives rootBox minHeight: 100vh for the
                  // sign-in page; without this override the avatar's invisible box spans
                  // the viewport and swallows clicks on "Order History" below it.
                  rootBox: { minHeight: 'auto', width: 'auto' },
                  avatarBox: "w-10 h-10"
                }
              }}
            />
          </SignedIn>
        </div>
      </div>
    </header>
  );
};
